import gql from 'graphql-tag';

export const GET_CURSOR_PAGINATED_POSTS = gql`
query cursorPaginatedPosts($first: Int=50, $after: String, $search: String) {
  cursorPaginatedPosts(first: $first, after: $after, search: $search) {
    edges { #post connection edge
      node { #post connection
        id
        title
        slug
        created_at
        thumbnail_url
        excerpt
        is_featured
        contents {
          id
          type
          data {
            ... on ImageContent {
              description
              url
              source
              photographer
            }
            ... on TextContent {
              text
            }
          }
        }
        category {
          id
          name
          slug
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      __typename
    }
    __typename
  }
}
`;

export const GET_CURSOR_PAGINATED_POST_BY_CATEGORY = gql`
query cursorPaginatedPostsByCategory($first: Int=50, $after: String, $category_slug: String!, $search: String) {
  categoryBySlug(slug: $category_slug) {
    id
    name
    slug
  }
  cursorPaginatedPostsByCategory(first: $first, after: $after, category_slug: $category_slug,search: $search) {
    edges { #post connection edge
      node { #post connection
        id
        title
        slug
        created_at
        thumbnail_url
        excerpt
        is_featured
        contents {
          id
          type
          data {
            ... on ImageContent {
              description
              url
              source
              photographer
            }
            ... on TextContent {
              text
            }
          }
        }
        category {
          id
          name
          slug
        }
      }
      cursor
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
      __typename
    }
    __typename
  }
}
`;

export const  GET_POST = gql`
  query post($id: ID!) {
    post(id: $id) {
      id
      title
      excerpt
      slug
      thumbnail_url
      source_url
      created_at
      updated_at
      is_featured
      contents {
        id
        type
        data {
          ... on ImageContent {
            description
            url
            source
            photographer
          }
          ... on TextContent {
            text
          }
          ... on HeadingContent {
            text
          }
        }
      }
      category {
        id
        name
        slug
      }
    }
  }
`;

export const GET_FEATURED_POSTS = gql`
  query featuredPosts {
    featuredPosts {
      id
      title
      slug
      created_at
      featured_image_url
      excerpt
      is_featured
      category {
        id
        name
        slug
      }
    }
  }
`;

export const INCREMENT_POST_VIEW_COUNT = gql`
  mutation IncrementPostViewCount($id: ID!) {
    incrementPostViewCount(id: $id)
  }
`;
